import React, { useState } from "react";
import parse from "html-react-parser";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import apiKey from "../../common/config/apiKey";
import apiCall from "../../common/config/apiCall";
import { BsInfoCircleFill } from "react-icons/bs";
import thumb from "../../common/images/recommended.webp";
import { FaStar } from "react-icons/fa";
import { nextPage } from "../../common/config/nextPage";
import MoreInfo from "../../common/Components/MoreInfo/MoreInfo";
import planIcon from "../../common/images/plan.webp";
import triangleImage from "../../common/images/searchcard.png";

const Grid = ({ product }) => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const location = useLocation();
  const pathname = location.pathname;
  const getDeparture = params.get("departure");
  const getArrival = params.get("arrival");
  const getPromocode = params.get("promocode");
  const getAirport = params.get("airport");

  const [show, setShow] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [singleProductDetail, setSingleProductDetail] = useState({});

  const handleBookNow = () => {
    setClicked(true);
    nextPage(
      `/booking?${new URLSearchParams({
        departure: getDeparture,
        arrival: getArrival,
        promocode: getPromocode,
        airport: getAirport,
        product: product?.sku.toString(),
      })}`
    );
  };

  const placeholderImage = "https://www.pngitem.com/pimgs/m/599-5998799_block-icon-clipart-hd-png-download.png";

  const onImageError = (e) => {
    e.target.src = placeholderImage;
  };

  const handleCallSingleProduct = async () => {
    const response = await apiCall(
      "get",
      `/product?key=${apiKey}&departure=${`${moment(getDeparture).format(
        "DD-MM-yyyy"
      )} ${moment(getDeparture).format("HH:mm")}`}&arrival=${`${moment(
        getArrival
      ).format("DD-MM-yyyy")} ${moment(getArrival).format("HH:mm")}`}&sku=${product?.sku
      }&discount_code=${getPromocode?.toString() || ""}&airport=${getAirport?.toString() || ""
      }&return_response=${"full"}`,
      {},
      {},
      pathname
    );
    if (response) {
      setSingleProductDetail(response?.data);
      setShow(true);
    }
  };

  const rawDesc = product?.short_description || "";
  let features = rawDesc
    .replace(/<\/(li|div|p)>|<br\s*\/?>/gi, '|||')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&quot;/gi, '"')
    .replace(/&apos;|&#39;/gi, "'")
    .split('|||')
    .map(s => s.replace(/:/g, "").trim())
    .filter(s => s.length > 0);

  if (features.length === 0) {
    features = [
      "Nestled between ocean & palmlined",
      "Nestled between ocean & palmlined shores beachside",
      "Nestled between ocean & palmlined",
      "Nestled between ocean & palmlined",
    ];
  }

  return (
    <div className="w-full flex flex-col bg-white rounded-[20px] overflow-hidden shadow-[0px_2px_20px_rgba(0,0,0,0.08)] relative">
      <MoreInfo show={show} setShow={setShow} product={singleProductDetail} />

      {/* Recommended Badge (Top) */}
      {(product?.offer === "recommended" || product?.offer) && (
        <div className="bg-[#F9F7A5] text-[#124D41] py-2.5 flex items-center justify-center font-bold text-[14px] tracking-wide w-full">
          <img src={thumb} alt="Thumb" className="size-6 mr-2 object-contain" />
          <span className="capitalize">{product?.offer || "Recommended"}</span>
        </div>
      )}

      {/* Gray Logo Section with Image Triangle */}
      <div className="relative w-full  bg-transparent rounded-b-[80px] pb-[40px]" >

        {/* Grey background layer */}
        {/* <div className="absolute top-0 left-0 w-full h-[180px] rounded-t-md bg-[#F4F5F6]"></div> */}

        {/* Triangle Image */}
        <img
          src={triangleImage}
          alt="Triangle Shape"
          className="absolute  size-full z-[2]  "
        />

        {/* Content Layer */}
        <div className="relative z-20 flex flex-col items-center pb-2 w-full h-full">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-[200px] rounded-[12px] "
            onError={onImageError}
          />
          <div className="bg-[#EEFE3E] rounded-full px-6 py-1.5 mt-3 text-[14px] font-bold text-[#124D41] mt-1 shadow-sm capitalize tracking-wide">
            {product.display_name || "Meet and Greet"}
          </div>
        </div>
      </div>

      {/* Price Section */}
      <div className="flex flex-col px-5 pt-3 pb-4 bg-white z-10">
        <span className="text-[12px] font-bold uppercase tracking-wider text-gray-500 mb-1">Just Price</span>

        <div className="flex flex-row items-center justify-between mb-3">
          <h2 className="text-[34px] font-black text-[#124D41] leading-none flex items-center">
            <span className="text-[20px] mr-1">£</span>
            {product?.pay_later_status ? parseFloat(product?.commission_price).toFixed(2) : product?.price}
          </h2>

          {/* Action Badges */}
          <div className="flex items-center gap-1.5">
            <button onClick={handleCallSingleProduct} className="bg-[#124D41] text-white flex items-center px-2 py-1.5 rounded-[4px] gap-1 hover:bg-black transition-colors cursor-pointer border border-[#124D41]">
              <BsInfoCircleFill className="text-[#EEFE3E] text-[10px]" />
              <span className="text-[12px] font-bold tracking-wide">More Info</span>
            </button>
            <div className="bg-[#124D41] text-white flex items-center px-2 py-1.5 rounded-[4px] gap-1 border border-[#124D41]">
              <FaStar className="text-[#EEFE3E] text-[10px]" />
              <span className="text-[12px] font-bold tracking-wide">{product?.average_rating ? parseFloat(product.average_rating).toFixed(1) : "5.0"} (Rating)</span>
            </div>
          </div>
        </div>

        <div className="text-[12px] text-[#124D41] font-bold leading-relaxed border-b border-slate-200 pb-3 flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-[#124D41] animate-pulse"></span>
          Last booked {React.useMemo(() => Math.floor(Math.random() * 50) + 2, [])} minutes ago
        </div>
      </div>

      {/* Features Section */}
      <div className="px-5 pb-5 bg-white flex-1 flex flex-col">
        {features.length > 0 && (
          <div className="bg-[#F4F5F6] rounded-[16px] p-4 flex flex-col w-full">
            {features.map((featureText, idx) => (
              <div key={idx} className="flex items-start w-full">
                <div className="flex-shrink-0 mt-0.5 mr-3">
                  <img
                    src={planIcon}
                    alt="Feature"
                    className="w-[22px] h-[22px] object-contain"
                  />
                </div>
                <div className={`flex-1 pb-3 ${idx !== features.length - 1 ? 'border-b border-dotted border-gray-300 mb-3' : ''}`}>
                  <span className="text-[12.5px] font-bold text-[#1A1A1A] leading-snug block pr-1">
                    {featureText}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>



      {/* Book Now Button */}
      <div className="bg-[#124D41] w-full p-2 mt-auto">
        <button onClick={handleBookNow} className="w-full text-center text-[#EEFE3E] font-black text-[22px] tracking-wide border border-dashed border-[#EEFE3E]/40 rounded-[8px] py-2 hover:bg-black/40 transition-all">
          Book Now
        </button>
      </div>

    </div>
  );
};

export default Grid;
